import SingleParcel from '../SingleParcel/SingleParcel';
import { CONFIRMATION } from '../../constants/strings';
import { Error } from '../../features/ErrorBoundary';

const renderContent = (barcodes = [], shipmentId, shipment, isSmallScreen) => {
  if (!barcodes.length) {
    return <Error title={CONFIRMATION.ERROR} />;
  }

  if (barcodes.length <= 3) {
    return (
      <SingleParcel
        barcodes={barcodes}
        shipmentId={shipmentId}
        shipment={shipment}
        isSmallScreen={isSmallScreen}
      />
    );
  }
};

const ParcelDisplay = ({ barcodes, shipmentId, shipment, isSmallScreen }) => (
  <>{renderContent(barcodes, shipmentId, shipment, isSmallScreen)}</>
);

export default ParcelDisplay;
